import $ from 'jquery';

function enableElement($elem) {
    if ($elem.length === 0) {
        return;
    }
    let wrapClass = ($elem.attr('data-wrap-class') || '').trim();
    let $html = $('<div></div>').html($elem.attr('data-html'));
    if (wrapClass) {
        $html.addClass(wrapClass);
    }
    $elem.replaceWith($html);
}

$('.two-click__button').on('click', function (ev) {
    ev.preventDefault();
    const $parent = $(this).closest('.two-click');
    const $check = $parent.find('.two-click__checkbox');

    if ($check.prop('checked') === true && $check.val()) {
        consentApi.enable($check.val(), true);
        return;
    }

    // enable single element, instead of relying on consentApi.
    enableElement($parent);
});

$('.two-click__checkbox').each((i, elem) => {
    const identifier = $(elem).val();
    const $parent = $(elem).closest('.two-click');

    consentApi.on(`enable:${identifier}`, () => {
        enableElement($parent);
    });
});
